import React, { useContext, useMemo, useState } from 'react'
import { injectIntl } from 'react-intl';
import { DashboardCardFormContext } from 'containers/DashboardCardForm';
import useOrganizations from 'utils/useOrganizations';
import AplanetIcon from 'components/AplanetIcon';
import ModalDashboardCardKpiSummary from 'containers/Dashboard/screens/ModalDashboardCardKpiSummary';
import './style.less';

const CardFormSummary = ({ intl }) => {

    const { values, currentStep } = useContext(DashboardCardFormContext);
    const { suborganization } = useOrganizations();
    const [showModal, setShowModal] = useState(false);

    const nodesByLevel = useMemo(() => ( values.selectedNodeLevel === 2 ) 
                                            ?  suborganization.children.map( subOrg => subOrg.id ) 
                                            : [ suborganization.id]
    , [suborganization.children, suborganization.id, values.selectedNodeLevel]);
    
    if ((values?.selectedRowKeys || []).length === 0){
        return null;
    }

    return (
        <div className="DashboardCardForm__summary">
            {
                (currentStep >= 0) && 
                <>
                    { intl.formatMessage(
                        {id: 'dashboard_card_form_summary_step_1'},
                        {value: values?.selectedRowKeys?.length || 0}
                    )}
                </>
            }

            {
                (currentStep >= 2) && 
                <>, { intl.formatMessage(
                    {id: 'dashboard_card_form_summary_step_2'},
                    {value: nodesByLevel.length || 0}
                )}</>
            }

            {
                (currentStep >= 3) && 
                (values.selectedRows[0].schema.type ==='table') && 
                <>, { intl.formatMessage(
                    {id: 'dashboard_card_form_summary_step_3'},
                    {value: values?.graphAddress?.length || 0}
                )}</>
            }

            {
                (currentStep >= 4) && 
                <>, { intl.formatMessage(
                    {id: 'dashboard_card_form_summary_step_4'},
                    {value: values?.periodsNumber || 0}
                )}</>
            }

            <button type='button' onClick={ () => setShowModal(true) }>
                <AplanetIcon name="circle-info" size="18px" />
            </button>

            <ModalDashboardCardKpiSummary 
                show={ showModal }
                onCancel={ () => setShowModal(false) }
                kpis={ values?.selectedRows?.map( kpi => ({ 
                    slug: kpi.slug,
                    name: kpi.name,
                    link: `/kpi/${kpi.slug}/last/data`
                }))}
            />

        </div>
    )
}

export default injectIntl(CardFormSummary);